jQuery(document).ready(function ($) {
    $('.homepage-hero-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        touchMove: false,
        speed: 4000,
        // autoplay: true,
        // autoplaySpeed: 6000,
        fade: true,
        cssEase: 'ease-in-out',
        infinite: false,
    });
    
    $('.homepage-hero-content-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        touchMove: false,
        speed: 4000,
        // autoplay: true,
        // autoplaySpeed: 6000,
        fade: true,
        cssEase: 'ease-in-out',
        asNavFor: '.homepage-hero-image-slider',
        infinite: false,
    });

    $( "body" ).on( "click", ".homepage-hero-content-left__tabs_item:not(.active)", function(event) {
        event.preventDefault();
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        var tab_border = $('.homepage-hero-content-left__tabs .tab_border');        
        var parentWidth = tab_border.offsetParent().width();
        var tab_borderW = Math.round(100 * tab_border.width() / parentWidth);
        var tab_index = $(this).attr('data-tab-index');
        tab_border.css('left', (tab_borderW*tab_index)+'%');
        $('.homepage-hero-content-left__heading_box.active').removeClass('active');
        $('div#banner_heading'+tab_index).addClass('active');
        $('.homepage-hero-content-slider').slick('slickGoTo', tab_index );
    });
});